import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@admin-env/environment';

@Injectable()
export class Redirect  {
    constructor(
      private router: Router
    ) {}

    public canActivate() {
      this.router.navigate([]);
      return false;
    }
}
